import { MouseEvent, useState } from "react";
import { IFormField } from "src/types/form.types";
import { Controller } from "react-hook-form";
import { IoEye } from "react-icons/io5";
import { IoMdEyeOff } from "react-icons/io";
import { getErrorMessage } from "src/utils/form.utils";

type Props = IFormField & {
    errors: any;
    control: any;
}
interface IState {
    showPassword: boolean;
}

const INITIAL_STATE: IState = { showPassword: false };

export const PasswordField = ({
    label,
    name,
    placeholder,
    disabled,
    autoFocus,
    control,
    errors,
}: Props) => {
    const [state, setState] = useState(INITIAL_STATE);
    const { showPassword } = state;
    const handleClickShowPassword = () =>
        setState((prevState) => ({
            ...prevState,
            showPassword: !prevState.showPassword,
        }));

    const handleMouseDownPassword = (event: MouseEvent<HTMLButtonElement>) => {
        event.preventDefault();
    };

    return (
        <>
            <label htmlFor={name} className="custom-label-field">
                {label}
            </label>
            <div className="relative flex items-center">
                <Controller
                    control={control}
                    name={name}
                    render={({ field }) => (
                        <input
                            type={showPassword ? "text" : "password"}
                            {...field}
                            placeholder={placeholder}
                            disabled={disabled}
                            autoFocus={autoFocus}
                            autoComplete="off"
                            name={name}
                            id={name}
                            className={`custom-input ${errors[name] ? "border-red-500" : ""
                                }`}
                        />
                    )}
                />

                <button
                    type="button"
                    onClick={handleClickShowPassword}
                    onMouseDown={handleMouseDownPassword}
                    className="flex-center absolute right-4 h-7 w-7 rounded-full bg-transparent"
                >
                    {showPassword ? (
                        <IoMdEyeOff className="h-4 w-4" />
                    ) : (
                        <IoEye className="h-4 w-4" />
                    )}
                </button>
            </div>
            {errors[name] && (<p
                className={`mt-4 text-left text-sm ${errors[name] ? "text-red-500" : ""
                    }`}
            >
                {getErrorMessage(errors[name].message,label)}
            </p>)}
        </>
    );
};

